import React, { useEffect, useState } from 'react';
import Icons from '../../../../common/widgets/Icons';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';
function VideoThumbnail(
  props: Readonly<{
    thumbnailsrc: string;
    videosrc: string;
    cache: Map<any, any>;
  }>,
) {
  const { thumbnailsrc, videosrc, cache } = props;
  const [thumbnail, setThumbnail] = useState<string | undefined>(() => {
    if (cache.has(videosrc)) {
      return cache.get(videosrc);
    }
    return undefined;
  });

  useEffect(() => {
    if (thumbnailsrc) {
      cache.set(videosrc, thumbnailsrc);
      setThumbnail(thumbnailsrc);
      return;
    }
    if (thumbnail) return;

    const video = document.createElement('video');
    video.src = props.videosrc;
    video.preload = 'metadata';
    video.crossOrigin = 'anonymous';

    video.addEventListener('loadeddata', () => {
      video.currentTime = 20;
    });

    video.addEventListener('seeked', () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.drawImage(video, 0, 0);

      const imgURL = canvas.toDataURL('image/jpeg');
      cache.set(videosrc, imgURL);
      setThumbnail(imgURL);
    });
  }, [cache, videosrc, thumbnail, thumbnailsrc, props.videosrc]);

  if (!thumbnail && !thumbnailsrc)
    return (
      <div className="tutorials-video-thumbnail-loading">
        <LoadingSpinner />
      </div>
    );

  return (
    <div className="tutorials-video-thumbnail-wrapper">
      <img
        src={thumbnail}
        alt="Thumbnail video"
        className="tutorials-video-thumbnail"
      />

      <span className="tutorials-video-thumbnail-top-image">
        <span className="tutorials-video-thumbnail-top-image-icon">
          <Icons.TutorialsVideoPlay />
        </span>
      </span>
    </div>
  );
}

export default React.memo(VideoThumbnail);
